import React, { useState } from 'react';
import { Alert,Button, Modal, ModalHeader, ModalBody, ModalFooter, FormText, Container, Col, Form, Row, FormGroup, Label, Input, } from 'reactstrap';
import SignatureCanvas from 'react-signature-canvas';
import FileViewer from 'react-file-viewer';
import { MdInfo } from 'react-icons/md'; //GoIssueClosed




const ModalFirma = (props) => {
   
    const {
        buttonLabel,
        className, informativo
    } = props;

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    const update = (e) => {
        console.log(props.state.EstadoModal);
        console.log(e.target.value);
        
        props.onUpdate(e.target.value);

    };



    const EstadoSolicitudVerModal = (e) => {

        console.log(props.state.EstadoModal);
      //  props.state.EstadoModal = e.target.value

        console.log(props.state.EstadoModal);

        toggle()
    }
    const ActualizarElemento = (e) => {
        console.log(e.target.value);
        props.onActualizar(props, props.state.EstadoModal)
        setModal(!modal);
    }

    const SaveValidateFormAdjunto  = () => {
        console.log(props);
        props.SaveValidateFormAdjunto()


    }
    const displayProcessR = () => {
        console.log(props);
        props.displayProcessR()


    }

    
    const SaveValidateFormselfie = () => {
            console.log(props);
        props.SaveValidateFormselfie()


        }

    const clear = (e) => {
        console.log(props);
        props.clear(props)
      
        
    }

    const trim = (e) => {
        console.log(props);

        props.trim(props)
        setModal(!modal);
       
    }

    const GetDocument = (e) => {
        console.log(props);
        props.GetDocument(props)
       
    }
    const modalFirma = () => {
        props.modalFirma()
    }


    if (props.state.Rol == "Admin" || props.state.Rol == "Analista de Crédito" || props.state.Rol == "Vendedor") {

        if (props.state.Estado == "EN REVISIÓN" ) {
            return (<div>
          
                <div  className="rowSubTitle">
                  
                    <h5 className="PageHeading">CONTRATO </h5>

                </div>
                <Row className="rowGris">
                    <Col sm={3}>
                        <FormGroup>
                            <Label for="exampleFile">Contrato</Label>


                            <div id="result5"></div>
                            <input type="file" id="files5" name="file5" onClick={displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                            <button type="button" id="upload-button5" value="5" className="btn btn-info" onClick={SaveValidateFormAdjunto}>Subir</button>
                            <Alert color="success" id="UploadAlert5" className="alertHide">
                                This is a success alert — check it out!
                              </Alert>
                            <Alert color="danger" id="UploadFailAlert5" className="alertHide">
                                This is a danger alert — check it out!
                              </Alert>
                            <FormText color="muted">

                            </FormText>
                        </FormGroup></Col></Row>
                        </div>)
        }

        else if (props.state.Estado == "CONTRATO ANEXADO") {
            return (<div>
                <hr />
                <div className="rowSubTitle">

                    <h5 className="PageHeading">CONTRATO </h5>

                </div>
                <Row className="rowGris">
                    <Col sm={3}>
                        <FormGroup>
                            <Label for="exampleFile">Contrato</Label>


                            <div id="result5"></div>
                            
                            <FormText color="muted">

                            </FormText>
                        </FormGroup></Col></Row>
            </div>)
        }

        else if (props.state.Estado == "EN REVISIÓN FIRMA Y SELFIE" || props.state.Estado  == "APROBADA" || props.state.Estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE" || props.state.Estado == "DISPERSADO") {

            return (
                <div>
                    <div>
                     
                        <div className="rowSubTitle">

                            <h5 className="PageHeading">CONTRATO </h5>

                        </div>
                        <Row className="rowGris">
                            <Col sm={3}>
                                <FormGroup>
                                    <Label for="exampleFile">Contrato</Label>


                                    <div id="result5"></div>

                                    <FormText color="muted">

                                    </FormText>
                                </FormGroup></Col></Row>

                
                        <div className="rowSubTitle">

                            <h5 className="PageHeading">FIRMA </h5>

                        </div>
               
                        <Row className="rowGris">
                            <Label for="exampleFile" sm='12'>Firma</Label>

                            <Col sm={12} className="textoCentrado">
                               

                                <img id="imagenFirmaGet" className="imagenFirmaGet position-relative form-group" sm={12} />
                                <Col sm={2} xs={12}>
                                </Col>


                            </Col>
                            <br/>
                            <div className="rowSubTitle">

                                <h5 className="PageHeading">SELFIE </h5>

                            </div>

                            <Col sm={12}>

                                <FormGroup >
                                    <Col sm={12} className='contentImageExample'>
                                        <Label for="exampleFile" sm='1'>Foto Selfie</Label><a alt='Ejemplo de foto' title='Ejemplo de foto' onClick={modalFirma}>     <img className='fotoSelfieEjemploPage' src='/images/fotoEjemplo.jpeg' /></a>

                                    </Col><Col sm={6} className="ContenedorImg  offset-lg-3"> <img id="fotoSelfie" /></Col>
                                    <Col sm={12} className="alinearDerecha">
                                    <div id="result6"></div>
                                    </Col>
                                </FormGroup>
                            </Col>

                        </Row>
                    </div>
                    <FormGroup row>




                    </FormGroup>


                </div>
            );

        }

        else {
            //solo regresar

            return (<div>
            </div>);

        }
    }
    else {

        if (props.state.Estado == "CONTRATO ANEXADO" || props.state.Estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {

            return (
                <div>
                    <div>
                  
                     
                        <div className="rowSubTitle">

                            <h5 className="PageHeading">CONTRATO </h5>

                        </div>
                        <Row className="rowGris">
                            <Col sm={3}>
                                <FormGroup>
                                    <Label for="exampleFile">Contrato</Label>


                                    <div id="result5"></div>

                                    <FormText color="muted">

                                    </FormText>
                                </FormGroup></Col></Row>

                       
                        <div className="rowSubTitle">

                            <h5 className="PageHeading">FIRMA </h5>

                        </div>
                        <Row className="rowGris">
                            <Label for="exampleFile" sm='12'>Firma</Label>

                            <Col sm={12} className="textoCentrado">
                                <img id="imagenFirmaGet" className="imagenFirmaGet position-relative form-group" sm={12} />
                                <Col sm={2} xs={12}>
                                </Col>
                                <Col sm={2} xs={3}>
                                    <Button color="success" className='btnFirmaSpace' onClick={EstadoSolicitudVerModal} >Firmar</Button>
                                </Col>

                            </Col>
                            <br />
                            <div className="rowSubTitle">

                                <h5 className="PageHeading">SELFIE </h5>

                            </div>

                            <Col sm={12}>
                                <FormGroup>
                                    <Col sm={12} className='contentImageExample'>
                                    <Label for="exampleFile" sm='1'>Foto Selfie</Label><a alt='Ejemplo de foto' title='Ejemplo de foto' onClick={modalFirma}>     <img className='fotoSelfieEjemploPage' src='/images/fotoEjemplo.jpeg' /></a>

                                    </Col><Col sm={6} className="ContenedorImg  offset-lg-3"> <img id="fotoSelfie" /></Col>
                                    <Col sm={12}>
                                        
                                    <div id="result6"></div>
                                    <input type="file" id="files6" name="file6" onClick={displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                                        
                                        <button type="button" id="upload-button6" value="6" className="btn btn-info" onClick={SaveValidateFormselfie}>Subir</button>
                                     </Col>
                                    <Alert color="success" id="UploadAlert6" className="alertHide">
                                        This is a success alert — check it out!
                              </Alert>
                                    <Alert color="danger" id="UploadFailAlert6" className="alertHide">
                                        This is a danger alert — check it out!
                              </Alert>
                                </FormGroup>
                            </Col>

                        </Row>
                    </div>
                    <FormGroup row>




                    </FormGroup>

                    <Modal isOpen={modal} className={className +" ModalFirmaUsuario"}>
                        <ModalHeader >Firma de contrato</ModalHeader>
                        <ModalBody>
                            <Label for="exampleFile3" sm='12'>Debe ingresar su firma</Label>

                            <FormGroup className="CentrarCanvas">
                                    
                                        <SignatureCanvas ref={(ref) => { props.state.sigPad = ref }} penColor='navy' backgroundColor='rgba(246,246,246,1)'
                                    canvasProps={{ width: 900, height: 200, className: 'sigCanvas' }} />
                                    
                                    



                                </FormGroup>
                            <Col sm={12}>
                                        <button type="button" onClick={clear} className="btn btn-secondary">Limpiar</button>
                                    </Col>

                        </ModalBody>
                        <ModalFooter>
                           
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={trim}>Aceptar</Button>{' '}
                        </ModalFooter>
                    </Modal>
                </div>
            );

        }
        else if (props.state.Estado == "EN REVISIÓN")
            {
            //solo regresar

            return (<div>
            </div>);

        }
        else if (props.state.Estado == "EN REVISIÓN FIRMA Y SELFIE" || props.state.Estado == "DISPERSADO" ) {

            return (
                <div>
                    
                    <div>
                        <div className="rowSubTitle">

                            <h5 className="PageHeading">CONTRATO </h5>

                        </div>
                    
                        <Row className="rowGris">
                            <Col sm={3}>
                                <FormGroup>
                                    <Label for="exampleFile">Contrato</Label>


                                    <div id="result5"></div>

                                    <FormText color="muted">

                                    </FormText>
                                </FormGroup></Col></Row>

                        <div className="rowSubTitle">
                            <h5 className="PageHeading">FIRMA    </h5>

                        </div>
                        <Row className="rowGris">
                            <Label for="exampleFile" sm='12'>Firma</Label>

                            <Col sm={12} className="textoCentrado">
                                
                                <img id="imagenFirmaGet" className="imagenFirmaGet position-relative form-group" sm={12} />
                                <Col sm={2} xs={12}>
                                </Col>
                                

                            </Col>


                            <div className="rowSubTitle">

                                <h5 className="PageHeading"> SELFIE </h5>

                            </div>

                            <Col sm={12}>
                                <FormGroup >
                                    
                                    <Col sm={12} className='contentImageExample'>
                                        <Label for="exampleFile" sm='1'>Foto Selfie</Label><a alt='Ejemplo de foto' title='Ejemplo de foto' onClick={modalFirma}>     <img className='fotoSelfieEjemploPage' src='/images/fotoEjemplo.jpeg' /></a>

                                    </Col> <Col sm={6} className="ContenedorImg offset-lg-3"> <img id="fotoSelfie" /></Col>
                                    <Col sm={12} className="alinearDerecha">
                                        <div id="result6"></div>
                                    </Col>
                                </FormGroup>
                            </Col>

                        </Row>
                    </div>
                    <FormGroup row>




                    </FormGroup>

                   
                </div>
            );

        }

        else {
            //solo regresar 

            return (<div>
               </div>);

        }

    }

        

    
}

export default ModalFirma;